import secondStepApiV4 from 'lib/api/secondStepApiV4'
import {
  mapNetSuiteCustomerToAssignFormData,
  mapSiteToAssignFormData,
} from './getReassignSiteData'

const loadReassignSiteDataFallback = async assetId => {
  const response = await secondStepApiV4.getNetSuiteAssetById(assetId)
  const site = response.data?.site
  const nsCustomerId = site?.nsCustomerId

  if (nsCustomerId) {
    const customerResponse = await secondStepApiV4.getNetSuiteCustomers({
      nsCustomerId,
    })
    const customers = customerResponse.data
    const customer = Array.isArray(customers) ? customers[0] : null

    if (customer) {
      return mapNetSuiteCustomerToAssignFormData(customer)
    }
  }

  return mapSiteToAssignFormData(site)
}

export default loadReassignSiteDataFallback
